<template>
    <div class="animated fadeIn">
        <b-row>
            <delivery-total
                :lgSize="12"
                :lgOffset="0"
                :locParam="0"
            />
            <delivery-total-courier
                :lgSize="12"
                :lgOffset="0"
                :locParam="0"
            />
        </b-row>
    </div>
</template>


<script>
import deliveryTotal from "../../components/DeliveryTotal";
import deliveryTotalCourier from "../../components/DeliveryTotalCourier";

export default {
  name: "reports",
  components: { deliveryTotal, deliveryTotalCourier }
}
</script>